import { render, staticRenderFns } from "./NormalSearchNav141.vue?vue&type=template&id=1620928a&scoped=true"
import script from "./NormalSearchNav141.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav141.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1620928a",
  null
  
)

export default component.exports